const EVENT_PARAM_KEY = {
  // Common
  SESSION_ID_GA: 'sessionIdGa',
  GCLID: 'gclid',
  FBCLID: 'fbclid',
  REFERRER: 'referrer',
  REFERRING_DOMAIN: 'referringDomain',
  SCREEN_NAME: 'screenName',
  SCREEN_SECTION: 'screenSection',
  PREVIOUS_SCREEN_NAME: 'previousScreenName',
  PREVIOUS_SCREEN_SECTION: 'previousScreenSection',
  ENVIRONMENT: 'environment',
  // UTM parameters
  UTM_CAMPAIGN: 'utmCampaign',
  UTM_CONTENT: 'utmContent',
  UTM_MEDIUM: 'utmMedium',
  UTM_SOURCE: 'utmSource',
  UTM_TERM: 'utmTerm',


  // Specific
  LOGIN_OR_SIGNUP_SOURCE: 'loginOrSignupSource',
  BUSINESS_VERTICAL: 'businessVertical',
  EVENT_CATEGORY: 'eventCategory',
  SEARCH_SUGGESTED_CAMPAIGN: 'searchSuggestedCampaign',
  SEARCH_FEATURE_SELECTED: 'searchFeatureSelected',
  SEARCH_FEATURE_POSITION: 'searchFeaturePosition',
  SEARCH_SUGGESTED_CAMPAIGN_NAME: 'searchSuggestedCampaignName',
  SEARCH_SUGGESTED_CAMPAIGN_NAME_COUNT: 'searchSuggestedCampaignNameCount',
  SEARCH_POPULAR_CATEGORY_KEYWORDS: 'searchPopularCategoryKeywords',
  SEARCH_POPULAR_CATEGORY_KEYWORDS_COUNT: 'searchPopularCategoryKeywordsCount',
  SEARCH_RECENT_KEYWORDS: 'searchRecentKeywords',
  SEARCH_RECENT_KEYWORDS_COUNT: 'searchRecentKeywordsCount',
  SEARCH_REFINEMENT_KEYWORDS: 'searchRefinementKeywords',
  SEARCH_REFINEMENT_KEYWORDS_COUNT: 'searchRefinementKeywordsCount',
  SEARCH_AUTOCOMPLETE_KEYWORDS: 'searchAutocompleteKeywords',
  SEARCH_AUTOCOMPLETE_KEYWORDS_COUNT: 'searchAutocompleteKeywordsCount',
  SEARCH_TRENDING_KEYWORDS: 'searchTrendingKeywords',
  SEARCH_TRENDING_KEYWORDS_COUNT: 'searchTrendingKeywordsCount',
  SEARCH_TERM: 'searchTerm',
  SEARCH_TERM_TYPED: 'searchTermTyped',
  SEARCH_PRODUCT_COUNT: 'searchProductCount',
  SEARCH_SEGMENTS: 'searchSegments',

  // Campaign
  NAME: 'name',
  SOURCE: 'source',
  MEDIUM: 'medium',
  TERM: 'term',
  CONTENT: 'content',

  CHECKOUT_FLOW: 'checkoutFlow',
  FULFILMENT_CHANNEL: 'fulfilmentChannel',

  // Product
  PROMOTION_COLLECTION_NAME: 'promotionCollectionName',
  PROMOTION_COLLECTION_POSITION: 'promotionCollectionPosition',
  PRODUCTS: 'products',
  PRODUCT_ID_DBP: 'productIdDbp',
  PRODUCT_ID_SAP: 'productIdSap',
  PRODUCT_NAME: 'name',
  BRAND: 'brand',
  FULFILMENT_TYPE: 'fulfilmentType',
  IS_MARKETPLACE_ITEM: 'isMarketplaceItem',
  PRICE_RETAIL: 'priceRetail',
  PRICE_DISCOUNTED: 'priceDiscounted',
  QUANTITY: 'quantity',
  NUMBER_OF_PROMOTIONS: 'numberOfPromotions',
  INVENTORY_STATUS: 'inventoryStatus',
  DISPLAY_UNIT: 'displayUnit',
  DIETARY_TYPE: 'dietaryType',
  RANK: 'rank',
  RATING: 'rating',
  CATEGORY_L1_ID: 'categoryL1Id',
  CATEGORY_L1: 'categoryL1',
  CATEGORY_L2_ID: 'categoryL2Id',
  CATEGORY_L2: 'categoryL2',
  CATEGORY_L3_ID: 'categoryL3Id',
  CATEGORY_L3: 'categoryL3',
  SELLER_ID: 'sellerId',
  SELLER: 'seller',
  STORE_ID_DBP: 'storeIdDbp',
  STORE_ID_SAP: 'storeIdSap',
  STORE: 'store',
  PRODUCT_OFFER_ID: 'productOfferId',
  PRODUCT_OFFER_TYPE: 'productOfferType',
  PRODUCT_OFFER_DESCRIPTION: 'productOfferDescription',
  PRODUCT_OFFER_AMOUNT: 'productOfferAmount',
  PRODUCT_OFFER_APPLIED: 'productOfferApplied',
  CAMPAIGN_PREORDER_ID: 'campaignPreorderId',
  CAMPAIGN_PREORDER: 'campaignPreorder',

  // Voucher
  OFFER_ID: 'offerId',
  OFFER_TYPE: 'offerType',
  OFFER_SAP_REFERENCE: 'offerSapReference',
  VOUCHER_NAME: 'voucherName',
  VOUCHER_CODE: 'voucherCode',
  VOUCHER_POSITION: 'voucherPosition',
  VOUCHER_ADD_METHOD: 'voucherAddMethod',
  VOUCHER_ERROR_MESSAGE: 'voucherErrorMessage',

  // See all button click
  BUTTON_TYPE: 'buttonType',
  BUTTON_NAME: 'buttonName',
}

export { EVENT_PARAM_KEY }
